import { Corporation } from '@models/customer/corporation.model';
import { getActions } from './common/common.actions';
import { CommonState, initialState } from '@redux/common/common.state';
import { Injectable } from '@angular/core';
import { CommonEffects } from '@redux/common/common.effects';
import { getReducer } from '@redux/common/common.reducer';
import { getSelectors } from '@redux/common/common.selector';

export const corporationState: CommonState<Corporation> = initialState<Corporation>();
export const corporationStateKey = 'corporation';
export type CorporationState = CommonState<Corporation>;
export const corporationActions = getActions<Corporation>('Corporation');
export const corporationReducer = getReducer<Corporation>(corporationState, corporationActions);
export const corporationSelectors = getSelectors<Corporation>('corporation');

@Injectable()
export class CorporationEffects extends CommonEffects<Corporation> {
  constructor() {
    super();
    Object.assign(this, this.createEffects(corporationActions, corporationSelectors));
  }
}
